<template>
  <div class="markdown-messages">
    <template v-for="(message, index) in messages">
      <div class="message-item" :class="{'selected': containsMessage(selectors, message)}">
        <!-- 选择框 -->
        <div class="message-select" v-show="select">
          <el-checkbox
              :class="{disabled: containsMessage(disables, message)}"
              :value="containsMessage(selectors, message)"
              :disabled="containsMessage(disables, message)"
              @change="switchSelect(message, index)"
          ></el-checkbox>
        </div>

        <!-- 消息体 -->
        <div class="message-role" :style="{width: select ? '95%' : '100%'}"  @click="switchSelect(message, index)">
          <MarkdownItem :message="message" :markdown="message.role === 'assistant' && message.msgStatus !== -1 && !message.vipExpiredRechargeTip"/>
          <!-- 消息选项 -->
          <template v-if="message.role === 'assistant' && !message.vipExpiredRechargeTip">
            <div class="message-options" v-show="!select">
              <div class="message-options-item" title="重新回答"
                   @click="emitRefreshEvent(message, index)"
                   v-if="index === messages.length -1">
                <i class="el-icon-refresh"/>
              </div>
              <div class="message-options-item" title="复制" @click="emitCopyEvent(message, index)">
                <i class="el-icon-document-copy"/>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <!-- 选择后操作 -->
    <div class="close-selector" v-show="select">
      <div class="btn-item cancel" @click="emitSelectEvent">取消</div>
      <div class="btn-item share" @click="handlePicture">分享</div>
    </div>

  </div>
</template>
<script>
import MarkdownItem from '@/components/MarkdownItem.vue'

export default {
  name: 'MarkdownSelect',
  components: { MarkdownItem },
  props: {
    showSelect: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    showSelect(newVal) {
      console.log('showSelect update', newVal)
      this.select = newVal
    },
    messages() {
      console.log('messages update')
      this.select = this.showSelect
    },
  },
  computed: {
    imgData() {
      // 根据id排序
      return this.selectors.sort( (a, b) => a.id - b.id)
    }
  },
  data() {
    return {
      select: this.showSelect,
      disables: [], // 不可取消选择的消息
      selectors: [] // 选择的消息
    }
  },
  methods: {
    // 是否包含消息
    containsMessage(selectors, message) {
      return selectors.some(item => item.id === message.id)
    },
    // 选择/取消选择消息
    switchSelect(message, index) {
      if (!this.select) return
      if (!this.containsMessage(this.disables, message)) {
        // 添加或删除选择消息
        let messageIndex = this.selectors.findIndex(item => item.id === message.id)
        messageIndex !== -1 ? this.selectors.splice(messageIndex, 1) : this.selectors.push(message)
        this.$emit('select', this.selectors)
      }
    },
    // 图片预览
    handlePicture() {
      this.$nextTick(() => {
        this.$refs['templateAI'].handleDialogOpen()
      })
    },
    // 选中事件
    emitSelectEvent(message, index) {
      if (!this.select) {
        this.select = true
        this.disables =  [message] // 不可取消选择的消息
        let lastMsg = this.messages[index-1]
        this.selectors = [...this.disables]
        if (!!lastMsg) this.selectors.push(lastMsg)
      } else {
        this.select = false
        this.disables = []
        this.selectors = []
      }
      this.switchSelect(message)
    },
    // 重新生成事件
    emitRefreshEvent(message, index) {
      console.log('emitRefreshEvent', message, index)
      this.$emit('refresh', message, index)
    },
    // 复制事件
    emitCopyEvent(message, index) {
      console.log('emitCopyEvent', message, index)
      this.$emit('copy', message, index)
    },
    // 分享事件
    emitShareEvent(message, index) {
      console.log('emitShareEvent', message, index)
      this.$emit('share', message, index)
    }
  }
}
</script>
<style scoped lang="scss">
.markdown-messages {
  position: relative;
  display: flex;
  flex-direction: column;
}
.message-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
  padding: 10px;
  //border: 1px solid #F6F7FB;
  .message-role {width: 95%;}
  .message-select {width: 5%;}
}
.message-item.selected {
  border-radius: 20px;
  //border: 1px solid #fee1fd;
  //background-image:linear-gradient(120deg,#a1c4fd 0%,#c2e9fb 100%)
  background-image:linear-gradient(135deg,#e4eeff ,#fee1fd 100%)


}
::v-deep .message-select .disabled .el-checkbox__input.is-checked .el-checkbox__inner {
  color: #ffffff;
  background-color: #878AAB;
  border-color: #878AAB;
}
.message-role {
  display: flex;
  flex-direction: column;
}
.message-options {
  margin-top: 10px;
  width: fit-content;
  display: flex;
  justify-content: space-between;

  .message-options-item {
    margin-right: 10px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    height: 32px;
    line-height: 32px;
    text-align: center;
    width: initial;
    padding: 0 12px;
    border-radius: 8px;
    color: #ffffff;
    background-color: #FCBA46;
    &:hover {background-color: #F4A215}

    span {
      font-weight: normal;
      color: #ffffff;
    }
  }
}
.close-selector {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  background-color: #F6F7FB;
  z-index: 2;
  position: sticky;
  bottom: 0;

  .btn-item {
    font-size: 16px;
    cursor: pointer;
    padding: 5px 30px;
    margin: 0 5px;
    border-radius: 20px;
  }
  .cancel {
    color:  #333333;
    border: 1px solid #dde0ec;
    background-color: #ffffff;
  }
  .share {
    color:  #ffffff;
    background-color: #5B54E1;
    border: 1px solid #5B54E1;
    &:hover {
      background-color: #6d67de;
      border: 1px solid #6d67de;
    }
  }
}
</style>
